import { render, staticRenderFns } from "./index.html?vue&type=template&id=230bb182&scoped=true&external"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=230bb182&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=230bb182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bb182",
  null
  
)

export default component.exports